import { makeStyles } from '@material-ui/core'

export default makeStyles(() => ({
  drawer: {
    padding: '2rem'
  },
  drawerHeader: {
    alignItems: 'center',
    display: 'flex'
  },
  drawerCloseBtn: {
    marginLeft: 'auto'
  },
  list: {
    padding: '0.25rem 0'
  },
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
    '& > label': {
      margin: 0,
      '& > span:first-child': {
        padding: 0
      },
      '& > span:last-child': {
        marginLeft: 5
      }
    }
  }
}))